import { SLICE_NAME } from 'constants/common';
import { THEME_KEY } from 'constants/theme';
import { useSelector } from 'react-redux';

const useTheme = () => {
    const initial = useSelector((state) => state[SLICE_NAME.THEME].initialConfig);
    const defaultConfig = useSelector((state) => state[SLICE_NAME.THEME].defaultConfig);

    const primaryInitalColor = initial?.[THEME_KEY.PRIMARY];
    const secondaryInitalColor = initial?.[THEME_KEY.SECONDARY];

    return {
        primaryInitalColor,
        secondaryInitalColor,
        theme: initial,
        defaultConfig,
    };
};

export default useTheme;
